import { SearchFiltersInterface } from "./search.types"

export enum SearchTabTitles {
  recipes = 'recipes',
  cuisines = 'cuisines',
  ingredients = 'ingredients',
  cookingtime = 'cookingtime',
  servingsize = 'servingsize',
  mealtype = 'mealtype'
};


export const DIET_DICTIONARY: Record<string, string> = {
  nonVeg: '(diet:Non-Veg OR diet:Veg OR diet:Vegan OR diet:Egg)',
  veg: '(diet:Veg OR diet:Vegan)',
  vegan: 'diet:Vegan',
  egg: '(diet:Veg OR diet:Vegan OR diet: Egg)'
}

export const COOKING_TIME_DICTIONARY: Record<string, string> = {
  'More than 30 mins': 'cooking_time > 30',
  'Below 30 mins': 'cooking_time < 30',
}

export const DEFAULT_FILTERS: SearchFiltersInterface = {
  cuisineFilter: [],
  ingredientFilter: [],
  timeFilter: "",
  courseFilter: "",
  servingSizeFilter: [],
  mealTypeFilter: [],
}